import React, { useState } from 'react';
import { InputNumber } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import './border-radius-input.less';
import { IBorderRadiusProps } from '@meitu/saas-editor-core/es/version-types';
import { useLocaleStore } from '@/i18n/index';

const BorderRadiusInput: React.FC<{
    closeClick: Function;
    borderRadius: IBorderRadiusProps;
    onChange: (borderRadius: IBorderRadiusProps, insEnd: boolean) => void;
}> = ({ closeClick, borderRadius, onChange }) => {
    const [borderRadiusShow, setBorderRadiusShow] = useState(borderRadius);
    const { $t } = useLocaleStore();
    return (
        <div className="c-border-radius-input" data-operate-type="canDrag">
            <div className="header" data-operate-type="canDrag">
                <div className="title" data-operate-type="canDrag">
                    <IconFont name="AmplificationBold" fontSize={14} color="var(--content-btn-transparency)" />
                    <span>{$t((v) => v.imageEffectPanel.borderRadiusItem.title)}</span>
                </div>
                <div className="close" onClick={() => closeClick()}>
                    <IconFont name="CrossBlack" fontSize={12} color="var(--content-system-secondary)" />
                </div>
            </div>

            <div className="content">
                <div className="item">
                    <IconFont name="UpperLeftBold" fontSize={24} color="var(--content-system-tertiary)" />
                    <InputNumber
                        min={0}
                        max={100}
                        onChange={(value) => {
                            const data = {
                                ...borderRadiusShow,
                                leftTop: value || 0,
                            };
                            setBorderRadiusShow(data);
                            onChange(data, true);
                        }}
                        value={borderRadiusShow.leftTop}
                    />
                </div>

                <div className="item">
                    <IconFont name="UpperRight" fontSize={24} color="var(--content-system-tertiary)" />
                    <InputNumber
                        min={0}
                        max={100}
                        onChange={(value) => {
                            const data = {
                                ...borderRadiusShow,
                                rightTop: value || 0,
                            };
                            setBorderRadiusShow(data);
                            onChange(data, true);
                        }}
                        value={borderRadiusShow.rightTop}
                    />
                </div>

                <div className="item">
                    <IconFont name="LeftLowerBold" fontSize={24} color="var(--content-system-tertiary)" />
                    <InputNumber
                        min={0}
                        max={100}
                        onChange={(value) => {
                            const data = {
                                ...borderRadiusShow,
                                leftBottom: value || 0,
                            };
                            setBorderRadiusShow(data);
                            onChange(data, true);
                        }}
                        value={borderRadiusShow.leftBottom}
                    />
                </div>

                <div className="item">
                    <IconFont name="LowRightBold" fontSize={24} color="var(--content-system-tertiary)" />
                    <InputNumber
                        min={0}
                        max={100}
                        onChange={(value) => {
                            const data = {
                                ...borderRadiusShow,
                                rightBottom: value || 0,
                            };
                            setBorderRadiusShow(data);
                            onChange(data, true);
                        }}
                        value={borderRadiusShow.rightBottom}
                    />
                </div>
            </div>
        </div>
    );
};
export default BorderRadiusInput;
